import { useEffect, useRef, useState } from 'react';
import { DialogUI } from '../Interface';
import { useFormikContext } from 'formik';
import { Box, Typography } from '@mui/material';
import { sxConfig } from '../Interface/interface.style';
import { ProjectMain } from './ProjectMain';

const ProjectDialog = ({ showDialog, onClose }) => {
  const { values, setFieldValue, setValues } = useFormikContext();
  const [selectedProject, setSelectedProject] = useState(null);
  const documentValuesRef = useRef(values);
  const documentValuesBeforeOpenRef = useRef(null);

  documentValuesRef.current = values;

  useEffect(() => {
    if (showDialog) {
      documentValuesBeforeOpenRef.current = documentValuesRef.current;
    }
  }, [showDialog]);

  const handleClose = async () => {
    const projectId = selectedProject?.projectId ?? null;
    const documentValuesBeforeOpen = documentValuesBeforeOpenRef.current;

    try {
      if (onClose) {
        // ha nincs kiválasztott cikk, null-lal hívjuk vissza
        await onClose(projectId, setFieldValue);
      }
    } finally {
      if (documentValuesBeforeOpen) {
        await setValues(
          projectId ? { ...documentValuesBeforeOpen, projectId } : documentValuesBeforeOpen,
          false
        );
      }

      documentValuesBeforeOpenRef.current = null;
      setSelectedProject(null);
    }
  };

  return (
    <DialogUI
      open={showDialog}
      headerContent={'Projekt'}
      fullWidth={true}
      onClose={handleClose}
      closeBtn={true}
      actionsContent={
        selectedProject?.projectId ? (
          <Box sx={sxConfig.dialogActionContent}>
            <Typography variant="body2" noWrap sx={sxConfig.dialogActionContentTypography1}>
              Választott projekt:
              <Box component="span" sx={sxConfig.dialogActionContentTypography2}>
                {selectedProject?.projectName}
              </Box>
            </Typography>
          </Box>
        ) : null
      }
      maxWidth="xl"
    >
      {showDialog && <ProjectMain fromDialog={true} dialogSetSelectedProject={setSelectedProject} />}
    </DialogUI>
  );
};

export default ProjectDialog;
